import { Circle } from '@mui/icons-material';
import useCasinoTabs from '../../hooks/useCasinoTabs';
import ProtectedNavigate from '../atoms/ProtectedNavigate';
import TabNavigation from './TabNavigation';

const CasinoNavigation = () => {
  const tabs = useCasinoTabs();
  return <TabNavigation tabs={tabs} icon={<Circle fontSize='inherit' />} />;
};

export const CasinoNavigate = ({ replace }: { replace?: boolean }) => {
  const tabs = useCasinoTabs();
  return <ProtectedNavigate tabs={tabs} replace={replace} />;
};

export default CasinoNavigation;
